// Shared visual language for the auth screens (BetaEntry, TastingBanner).
//
// NomLoop's palette `C` and <BrandLogo> live inside NomLoop.jsx and are not
// exported. Rather than couple these components to that 5400-line module (or
// duplicate the gradient five times), they accept `C` as a prop and fall back
// to this DEFAULT_C — so they render correctly standalone and in tests, and
// pick up the real palette when NomLoop passes it.

export const DEFAULT_C = {
  greenDark:  "#1f6f43",
  green:      "#2e8b57",
  greenLight: "#5fae7e",
  white:      "#ffffff",
  charcoal:   "#2c2c2c",
};

/** Full-viewport gradient screen used by BetaEntry / set-password / sign-in. */
export function screenStyle(C) {
  return {
    minHeight: "100vh",
    background: `linear-gradient(160deg, ${C.greenDark} 0%, ${C.green} 55%, ${C.greenLight} 100%)`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 24px",
    textAlign: "center",
  };
}

export const cardStyle = {
  background: "rgba(255,255,255,.12)",
  borderRadius: 20,
  padding: "28px 24px",
  maxWidth: 400,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: 14,
};

export function primaryButtonStyle(C) {
  return {
    padding: "15px",
    borderRadius: 12,
    border: "none",
    background: C.white,
    color: C.greenDark,
    fontWeight: 800,
    fontSize: 16,
    fontFamily: "inherit",
    cursor: "pointer",
  };
}

export function secondaryButtonStyle() {
  return {
    padding: "14px",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,.6)",
    background: "transparent",
    color: "#fff",
    fontWeight: 700,
    fontSize: 15,
    fontFamily: "inherit",
    cursor: "pointer",
  };
}
